import * as runtime from '@/api/runtime'
import {
  BatchBibliographyCollectionExportRequest,
  BatchBibliographyCollectionExportRequestToJSON
} from '@/api/models/batch/BatchBibliographyCollectionExportRequest'

/**
 * 書誌・所蔵データエクスポート
 */
export class BatchBibliographyCollectionExportApi extends runtime.BaseAPI {
  async export(
    request: BatchBibliographyCollectionExportRequest
  ): Promise<any> {
    const response = await this.requestPost(
      `/batch/bibliography/export`,
      BatchBibliographyCollectionExportRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
